import { NOT_SELECTED_REASONS, REJECTION_REASONS } from '../constants/hiring';

const rejectionLabels = Object.fromEntries(REJECTION_REASONS.map(r => [r.code, r.label]));
const notSelectedLabels = Object.fromEntries(NOT_SELECTED_REASONS.map(r => [r.code, r.label]));

export function suggestStatusNote(stage, app = {}) {
  switch (stage) {
    case 'submitted':
      return 'Submitted for review';
    case 'selected':
      return 'Selected — OK to schedule interview';
    case 'not_selected':
      return app.notSelectedReasonCode
        ? `Not selected — ${notSelectedLabels[app.notSelectedReasonCode] || app.notSelectedReasonCode}`
        : 'Not selected — will not proceed to interview';
    case 'interview':
      return 'Moved to interview — schedule the first round';
    case 'shortlisted':
      return 'Shortlisted after interview — awaiting offer decision';
    case 'offer':
      return 'Offer extended — awaiting candidate response';
    case 'joined':
      return 'Candidate marked as joined';
    case 'relieved':
      return 'Candidate relieved';
    case 'rejected':
      return app.rejectionReasonCode
        ? `Rejected — ${rejectionLabels[app.rejectionReasonCode] || app.rejectionReasonCode}`
        : 'Application rejected';
    default:
      return app.statusNotes || '';
  }
}
